module.exports = __webpack_public_path__ + "c5c37be.woff";